// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1_yWR","productName":"Table_productName__2ncOF"};